
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BodyImage extends Vue {
  @Prop() imageSrc!: string;
  @Prop() imageAlt!: string;

}
